export const softwareCompanies = [
  { label: 'APAC - Accounting & Tax', value: 'APAC - Accounting & Tax' },
  { label: 'APAC - ERP', value: 'APAC - ERP' },
  { label: 'APAC - People & Payroll', value: 'APAC - People & Payroll' },
  { label: 'Central', value: 'Central' },
  { label: 'ERP - Construction', value: 'ERP - Construction' },
  { label: 'ERP - Core', value: 'ERP - Core' },
  { label: 'ERP - Small Business', value: 'ERP - Small Business' },
  { label: 'ERP - Specialised', value: 'ERP - Specialised' },
  { label: 'HOS - Accommodation', value: 'HOS - Accommodation' },
  { label: 'HOS - Food and Beverage', value: 'HOS - Food and Beverage' },
  { label: 'HSC - Care', value: 'HSC - Care' },
  { label: 'HSC - Healthcare', value: 'HSC - Healthcare' },
  { label: 'HSC - Local Gov & Tech', value: 'HSC - Local Gov & Tech' },
  { label: 'Legal', value: 'Legal' },
  { label: 'NPE - Core', value: 'NPE - Core' },
  { label: 'Payments', value: 'Payments' },
  { label: 'PPL - Learn', value: 'PPL - Learn' },
  { label: 'PPL - MLB', value: 'PPL - MLB' },
  { label: 'PPL - SMB', value: 'PPL - SMB' },
  { label: 'Recruitment', value: 'Recruitment' },
];